import styled from "styled-components"

export const RootStyled = styled.div``
